<template>
	<div class="switcher">
		<input
			@change="onToggleSwitcher"
			type="checkbox"
			:id="id"
			class="switcher-input"
			:checked="state"
			:disabled="disabled"
		/>
		<label :for="id" class="switcher-label" />
	</div>
</template>

<script setup lang="ts">
const props = defineProps({
	state: { type: Boolean, default: false },
	disabled: { type: Boolean, default: false },
	id: { type: String, default: 'toggle' }
})

const emit = defineEmits<{
	toggleSwitcher: [value: boolean]
}>()

function onToggleSwitcher() {
	emit('toggleSwitcher', !props.state)
}
</script>

<style lang="scss" scoped>
.switcher {
	position: relative;
	display: inline-block;

	&-input {
		display: none;

		&:checked {
			& + .switcher-label {
				background-color: var(--action-primary);
				&:after {
					left: 22px;
				}
			}
		}
	}

	&-label {
		display: block;
		width: 40px;
		height: 21px;
		background-color: var(--background-muted);
		border-radius: var(--radius-full);
		cursor: pointer;
		transition: $transition-bg;
		&:after {
			content: '';
			position: absolute;
			top: 2px;
			left: 2px;
			width: 16px;
			height: 16px;
			background-color: var(--background-primary);
			border-radius: 50%;
			transition: left 0.3s ease;
		}
	}
}
</style>
